export const ItemStrings = {
    lensOfTruth: "lensOfTruth",
    ironBoots: "ironBoots",
    bombs: "bombs",
    bow: "bow",
    hoverBoots: "hoverBoots",
    hookshot: "hookshot",
    hammer: "hammer",
    mirrorShield: "mirrorShield",
    silverGauntlets: "silverGauntlets",
    zeldasLullaby: "zeldasLullaby",
    songOfTime: "songOfTime",
    goronTunic: "goronTunic",
    minuetOfForest: "minuetOfForest",
    serenadeOfWater: "serenadeOfWater",
    requiemOfSpirit: "requiemOfSpirit",
    nocturneOfShadow: "nocturneOfShadow",
    boleroOfFire: "boleroOfFire",
    rupee1: "rupee1",
    rupee5: "rupee5",
    rupee20: "rupee20",
    recoveryHeart: "recoveryHeart",
}

export function buildInventory() {
    return {
        items: {
            bombs: buildItem('Bombs', 'bombs.png', 'Allows you to destroy <img class="tooltipIcon" src="images/obstacles/boulder.png" /> <i>Boulders</i>.'),
            lensOfTruth: buildItem('Lens of Truth', 'lens-of-truth.png', 'Dispels <img class="tooltipIcon" src="images/obstacles/illusion.png" /> <i>Illusions</i>.'),
            bow: buildItem('Bow', 'bow.png', 'Allows you to trigger <img class="tooltipIcon" src="images/obstacles/eye-switch.png" /> <i>Eye Switches</i>.'),
            goronTunic: buildItem('Goron Tunic', 'goron-tunic.png', 'Allows you to traverse <img class="tooltipIcon" src="images/obstacles/lava.png" /> <i>Lava</i>.'),
            ironBoots: buildItem('Iron Boots', 'iron-boots.png', 'Allows you to traverse <img class="tooltipIcon" src="images/obstacles/underwater.png" /> <i>Underwater</i> squares.'),
            hoverBoots: buildItem('Hover Boots', 'hover-boots.png', 'Allows you to traverse over <img class="tooltipIcon" src="images/obstacles/void.png" /> <i>Void</i> squares.'),
            hookshot: buildItem('Hookshot', 'hookshot.png', 'Allows you to reach <img class="tooltipIcon" src="images/obstacles/hook-point.png" /> <i>Hook Targets</i>.'),
            hammer: buildItem('Megaton Hammer', 'hammer.png', 'Allows you to activate <img class="tooltipIcon" src="images/obstacles/switch.png" /> <i>Heavy Switches</i>.'),
            mirrorShield: buildItem('Mirror Shield', 'mirror-shield.png', 'Allows you to activate <img class="tooltipIcon" src="images/obstacles/sun-pattern.png" /> <i>Sun Patterns</i>.'),
            silverGauntlets: buildItem('Silver Gauntlets', 'silver-gauntlets.png', 'Allows you to pick up <img class="tooltipIcon" src="images/obstacles/pillar.png" /> <i>Giant Pillars</i>.'),
        },
        songs: {
            zeldasLullaby: buildItem('Zelda\'s Lullaby', 'zeldas-lullaby.png', 'Allows you to activate <img class="tooltipIcon" src="images/obstacles/royal.png" /> <i>Royal Insignias</i>.'),
            songOfTime: buildItem('Song of Time', 'song-of-time.png', 'Allows you to remove <img class="tooltipIcon" src="images/obstacles/time-block.png" /> <i>Time Blocks</i>.'),
            minuetOfForest: buildItem('Minuet of Forest', 'minuet-of-forest.png', 'Allows you to enter the <i>Forest Temple</i>.'),
            serenadeOfWater: buildItem('Serenade of Water', 'serenade-of-water.png', 'Allows you to enter the <i>Water Temple</i>.'),
            requiemOfSpirit: buildItem('Requiem of Spirit', 'requiem-of-spirit.png', 'Allows you to enter the <i>Spirit Temple</i>.'),
            nocturneOfShadow: buildItem('Nocturne of Shadow', 'nocturne-of-shadow.png', 'Allows you to enter the <i>Shadow Temple</i>.'),
            boleroOfFire: buildItem('Bolero of Fire', 'bolero-of-fire.png', 'Allows you to enter the <i>Fire Temple</i>.')
        },
        medallions: {
            light: buildItem('Light Medallion', 'light-medallion.png', 'Received from Rauru for completing Hyrule Field.'),
            forest: buildItem('Forest Medallion', 'forest-medallion.png', 'Received from Saria for completing the Forest Temple.'),
            water: buildItem('Water Medallion', 'water-medallion.png', 'Received from Princess Ruto for completing the Water Temple.'),
            shadow: buildItem('Shadow Medallion', 'shadow-medallion.png', 'Received from Impa for completing the Shadow Temple.'),
            spirit: buildItem('Spirit Medallion', 'spirit-medallion.png', 'Received from Nabooru for completing the Spirit Temple.'),
            fire: buildItem('Fire Medallion', 'fire-medallion.png', 'Received from Darinua for completing the Fire Temple.'),
        },
        rupees: 0,
        goldSkulltulas: 0,
        hearts: 3,
        heartPieces: 0
    }
}

export function setInventoryFunctions(inventory) {
    inventory.getItem = function(itemString) {
        if(itemString == ItemStrings.lensOfTruth)
            return this.items.lensOfTruth;
        else if(itemString == ItemStrings.ironBoots)
            return this.items.ironBoots;
        else if(itemString == ItemStrings.bombs)
            return this.items.bombs;
        else if(itemString == ItemStrings.bow)
            return this.items.bow;
        else if(itemString == ItemStrings.hoverBoots)
            return this.items.hoverBoots;
        else if(itemString == ItemStrings.hookshot)
            return this.items.hookshot;
        else if(itemString == ItemStrings.hammer)
            return this.items.hammer;
        else if(itemString == ItemStrings.mirrorShield)
            return this.items.mirrorShield;
        else if(itemString == ItemStrings.silverGauntlets)
            return this.items.silverGauntlets;
        else if(itemString == ItemStrings.goronTunic)
            return this.items.goronTunic;
        else if(itemString == ItemStrings.zeldasLullaby)
            return this.songs.zeldasLullaby;
        else if(itemString == ItemStrings.songOfTime)
            return this.songs.songOfTime;
        else if(itemString == ItemStrings.minuetOfForest)
            return this.songs.minuetOfForest;
        else if(itemString == ItemStrings.serenadeOfWater)
            return this.songs.serenadeOfWater;
        else if(itemString == ItemStrings.requiemOfSpirit)
            return this.songs.requiemOfSpirit;
        else if(itemString == ItemStrings.nocturneOfShadow)
            return this.songs.nocturneOfShadow;
        else if(itemString == ItemStrings.boleroOfFire)
            return this.songs.boleroOfFire;
    }

    inventory.checkMedallions = function() {
        return this.medallions.light.acquired && 
        this.medallions.shadow.acquired && 
        this.medallions.fire.acquired && 
        this.medallions.water.acquired && 
        this.medallions.spirit.acquired && 
        this.medallions.forest.acquired;
    }
}

function buildItem(name, iconFileName, description) {
    return {
        name,
        iconFileName,
        description,
        acquired: false
    }
}